import { useBoardViewsPopoverUpsellQuery } from './BoardViewsPopoverUpsellQuery.generated';
import { useFreeTrialEligibilityRules } from 'app/src/components/FreeTrial';
import { ProductFeatures } from '@trello/product-features';

export const useBoardViewsPopoverUpsell = ({ orgId }: { orgId?: string }) => {
  const { data, loading } = useBoardViewsPopoverUpsellQuery({
    variables: {
      orgId: orgId!,
    },
    skip: !orgId,
  });

  const organization = data?.organization;
  const products = organization?.products;
  const isFreeTeam = Boolean(organization && products && !products[0]);

  const isStandardTeam = Boolean(
    organization && products && ProductFeatures.isStandardProduct(products[0]),
  );

  const {
    isEligible: isFreeTrialEligible,
    startFreeTrial,
    isAdmin,
  } = useFreeTrialEligibilityRules(orgId);

  const shouldDisplayFreeTrialStep =
    (isStandardTeam || isFreeTeam) && isFreeTrialEligible;

  // Free or Standard team, not eligible for Free Trial
  const shouldDisplayUpgradeStep =
    (isStandardTeam || isFreeTeam) && !isFreeTrialEligible;

  const step = shouldDisplayFreeTrialStep
    ? 'freetrial'
    : shouldDisplayUpgradeStep
    ? 'upgrade'
    : null;

  const isUpsellEnabled = Boolean(organization && step && !loading);

  return {
    activateFreeTrial: () =>
      startFreeTrial(
        {
          redirect: false,
        },
        'boardViewsInlineDialog',
      ),
    isUpsellEnabled,
    step,
    isAdmin,
  };
};
